import React, { useState } from 'react'

import { PRESETS, fmtDate, addDays } from './helpers/trial_data'

const COPY = {
  extend: { title: 'Extend Trial', icon: 'fa-calendar-plus', btn: 'Extend Trial', btnClass: 'tp-btn--primary' },
  expire: { title: 'Expire Trial', icon: 'fa-circle-stop', btn: 'Expire Trial', btnClass: 'tp-btn--danger' },
  reenable: { title: 'Re-enable Trial', icon: 'fa-rotate-right', btn: 'Re-enable Trial', btnClass: 'tp-btn--success' },
}

const getInitials = (name) => name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase()

const TrialActionModal = ({ mode, trial, busy, onClose, onConfirm }) => {
  const grantsTime = mode === 'extend' || mode === 'reenable'
  const [presetKey, setPresetKey] = useState(mode === 'reenable' ? '1m' : '1w')
  const [custom, setCustom] = useState(false)
  const [customDays, setCustomDays] = useState(14)
  const [reason, setReason] = useState('')

  if (!trial) return null

  const days = custom
    ? Math.max(1, parseInt(customDays, 10) || 0)
    : (PRESETS.find((p) => p.key === presetKey) || {}).days || 0
  const base = mode === 'reenable' ? new Date() : trial.endDate
  const newEnd = addDays(base, days)

  const copy = COPY[mode]
  const canConfirm = reason.trim().length > 0 && (!grantsTime || days > 0) && !busy

  const handleConfirm = () => {
    if (!canConfirm) return
    onConfirm({ mode, trialId: trial.id, days, newEnd, reason: reason.trim() })
  }

  return (
    <div
      className='tp-modal-overlay'
      onMouseDown={onClose}
    >
      <div
        className='tp-modal'
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className='tp-modal-head'>
          <div className='tp-modal-title'>
            <span className={'tp-modal-glyph tp-modal-glyph--' + mode}>
              <i className={'fa-solid ' + copy.icon} />
            </span>
            <span>{copy.title}</span>
          </div>
          <button
            className='tp-modal-close'
            aria-label='Close'
            onClick={onClose}
          >
            <i className='fa-solid fa-xmark' />
          </button>
        </div>
        <div className='tp-modal-body'>
          <div className='tp-ident'>
            <span className='tp-avatar'>{getInitials(trial.name)}</span>
            <div>
              <div className='tp-ident-name'>
                {trial.name} <span className='tp-ident-id'>&middot; {trial.id}</span>
              </div>
              <div className='tp-ident-sub'>{trial.email}</div>
            </div>
          </div>
          {mode === 'expire' && (
            <div className='tp-warn'>
              <i className='fa-solid fa-triangle-exclamation' />
              <p>
                This force-stops the running trial and revokes the free access to Data Pulse immediately. The trial
                will move to <strong>Expired</strong>. <br />You can Re-enable it later.
              </p>
            </div>
          )}
          {grantsTime && (
            <div className='tp-section'>
              <div className='tp-field-label'>{mode === 'reenable' ? 'Grant Duration' : 'Add Duration'}</div>
              <div className='tp-preset-row'>
                {PRESETS.map((p) => (
                  <button
                    key={p.key}
                    type='button'
                    className={'tp-preset' + (!custom && presetKey === p.key ? ' active' : '')}
                    onClick={() => { setCustom(false); setPresetKey(p.key) }}
                  >
                    {p.label}
                  </button>
                ))}
                <button
                  type='button'
                  className={'tp-preset' + (custom ? ' active' : '')}
                  onClick={() => setCustom(true)}
                >
                  Custom
                </button>
              </div>
              {custom && (
                <div className='tp-custom-row'>
                  <input
                    type='number'
                    min='1'
                    className='tp-custom-input'
                    value={customDays}
                    onChange={(e) => setCustomDays(e.target.value)}
                  />
                  <span className='tp-custom-suffix'>days</span>
                </div>
              )}
              <div className='tp-endpreview'>
                <div className='tp-endpreview-row'>
                  <span>{mode === 'reenable' ? 'New start' : 'Current end date'}</span>
                  <strong>{fmtDate(base)}</strong>
                </div>
                <i className='fa-solid fa-arrow-right-long tp-endpreview-arrow' />
                <div className='tp-endpreview-row tp-endpreview-row--new'>
                  <span>New end date</span>
                  <strong>{fmtDate(newEnd)}</strong>
                </div>
              </div>
            </div>
          )}
          <div className='tp-section'>
            <div className='tp-field-label'>
              Reason <span className='tp-req'>required</span>
            </div>
            <textarea
              className='tp-reason'
              rows={3}
              placeholder='Why are you making this change?'
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>
        <div className='tp-modal-foot'>
          <button
            className='tp-btn tp-btn--light'
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className={'tp-btn ' + copy.btnClass}
            disabled={!canConfirm}
            onClick={handleConfirm}
          >
            {copy.btn}
          </button>
        </div>
      </div>
    </div>
  )
}

export default TrialActionModal
